import { Project } from 'mdello-client-ts/dist/src/interfaces/common/project.interface';
import { LocalStorageKey } from 'src/localStorage/enums/localStorageKey.enum';
import { getDataFromLocalStorage } from 'src/localStorage/getDataFromLocalStorage';

const currentProject: Project | undefined = getDataFromLocalStorage(
  LocalStorageKey.CURRENT_PROJECT
);

export const isCurrentProjectStimull = currentProject?._id === '6475d53f36eeee8e29db732b';
export const isCurrentProjectIntranet = currentProject?._id === '64340503821cfcd44c7c7997';
export const isCurrentProjectBuildy = currentProject?._id === '642d3e4404d6a856a7e0732b';
export const isCurrentProjectMSquare = currentProject?._id === '647445cb36eeee8e29db72fb';
export const isCurrentProjectCitizen = currentProject?._id === '62861dcc4bcf408cfc5dc3b9';
export const isCurrentProjectGulfMap = currentProject?._id === '654bb3ddd14525fdbf48f823';
